export default "__VITE_ASSET__B0PzV1Nu__";